import { lazy, Suspense, useEffect } from 'react'
import { useCart } from 'src/sdk/cart'
import { useUI } from 'src/sdk/ui/Provider'

const UIToast = lazy(() => import('src/components/ui/Toast'))

type ToastProps = {
  toastHiddenMessages: string[]
}

function Toast({ toastHiddenMessages }: ToastProps) {
  const { toasts, pushToast } = useUI()
  const { messages } = useCart()

  /**
   * Send cart notifications to toast in case the cart
   * returns warnings
   */
  useEffect(() => {
    if (!messages) {
      return
    }

    const shouldIgnore = (text: string) =>
      toastHiddenMessages.some((hiddenMessage) => text.includes(hiddenMessage))

    messages.forEach((message) => {
      if (shouldIgnore(message.text)) return

      pushToast({
        message: message.text,
        status: message.status,
      })
    })
  }, [messages, pushToast, toastHiddenMessages])

  return (
    <>
      {toasts.length > 0 && (
        <Suspense fallback={null}>
          <UIToast />
        </Suspense>
      )}
    </>
  )
}

export default Toast
